import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import Tag from '@/components/molecules/tag/tag';
import ShowMore from '@/components/utilities/show-more/show-more';
import styles from './text-description.module.scss';

export interface TextDescriptionProps {
  /** The text to show as headline */
  headline?: string;
  /** The list of tags to show */
  tags?: string[];
  /** The text to show as description */
  text?: string;
}

const TextDescription = ({
  headline,
  tags = [],
  text,
}: TextDescriptionProps) => {
  return (
    <div className={styles.component}>
      {tags.length > 0 && (
        <div className={styles.tags}>
          {tags.map((tag, tagIndex) => (
            <Tag key={tagIndex} text={tag} />
          ))}
        </div>
      )}

      {headline && (
        <Typography
          className={styles.headline}
          tag="h2"
          tagStyle="bodyLargeBold"
        >
          {headline}
        </Typography>
      )}

      {text && (
        <ShowMore height={300}>
          <RichText text={text} />
        </ShowMore>
      )}
    </div>
  );
};

TextDescription.displayName = 'TextDescription';

export default TextDescription;
